import moment from "moment";

import { paymentRequests } from "@/api/(requests)/payment";

import * as actionTypes from "./actionTypes";

export const updatePatientCardInfo = ({
  expirationDate,
  lastFourDigits,
  patientCardLoaded,
  username,
}) => {
  return {
    payload: {
      expirationDate,
      lastFourDigits,
      patientCardLoaded,
      username,
    },
    type: actionTypes.UPDATE_PATIENT_CARD_INFO,
  };
};

export const updatePatientPaywallInfo = ({
  isPaymentUpdateRequired,
  isSoftPaywall,
  lastFailedChargeDate,
  showPaywall,
}) => {
  return {
    payload: {
      isPaymentUpdateRequired,
      isSoftPaywall,
      lastFailedChargeDate,
      showPaywall,
    },
    type: actionTypes.UPDATE_PATIENT_PAYWALL_INFO,
  };
};

export const fetchPatientCardInfo = () => (dispatch) => {
  paymentRequests.fetchPatientCardInfo().then((data) => {
    const firstResult = data[0];

    if (firstResult) {
      dispatch(
        updatePatientCardInfo({
          expirationDate: firstResult?.expiration_date,
          lastFourDigits: firstResult?.last_four_digits,
          patientCardLoaded: true,
          username: firstResult?.username,
        }),
      );
    } else {
      dispatch(
        updatePatientCardInfo({
          patientCardLoaded: true,
        }),
      );
    }
  });
};

export const putPatientCardInfo =
  ({
    cardToken,
    expirationDate,
    finallyCallback = () => {},
    lastFourDigits,
    onErrorCallback = () => {},
    onSuccessCallback = () => {},
  }) =>
  (dispatch) => {
    paymentRequests
      .putPatientCardInfo({
        data: {
          expiration_date: expirationDate,
          last_four_digits: lastFourDigits,
          token: cardToken,
          type: "CREDIT_CARD",
        },
      })
      .then((response) => {
        const formattedExpDate = moment(expirationDate, "MMYY").format("YYYY-MM-DD");

        dispatch(
          updatePatientCardInfo({
            expirationDate: formattedExpDate,
            lastFourDigits: lastFourDigits,
          }),
        );

        dispatch(
          updatePatientPaywallInfo({
            isPaymentUpdateRequired: false,
            isSoftPaywall: false,
            lastFailedChargeDate: null,
            showPaywall: false,
          }),
        );
        onSuccessCallback(response);
      })
      .catch((err) => {
        onErrorCallback(err);

        return err;
      })
      .finally(finallyCallback);
  };

export const fetchPatientPaywall = () => (dispatch) => {
  paymentRequests.fetchPatientPaywall().then((data) => {
    const isSoftPaywall = data.paywall && data.type === "soft_paywall";

    dispatch(
      updatePatientPaywallInfo({
        isPaymentUpdateRequired: data.paywall && data.type === "hard_paywall_update_payment",
        isSoftPaywall,
        lastFailedChargeDate: data.last_failed_transaction_date,
        showPaywall: data.paywall,
      }),
    );
  });
};
